import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Repeat, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AutoRenewToggle = ({ booking, token, onSaved }) => {
  const [busy, setBusy] = useState(false);
  if (booking.status === "cancelled") return null;
  const on = !!booking.weekly_auto_renew;

  const toggle = async () => {
    const next = !on;
    if (next && !window.confirm(
      `Turn ON Weekly Auto-Renew for ${booking.name}?\n\nEvery time their paid-through date arrives, the system will automatically extend them 7 days at the weekly rate, add the charge to their balance, send them an invoice + pay link by text & email, and start the payment reminder cycle. You'll get an owner alert each time.`
    )) return;
    setBusy(true);
    try {
      await axios.post(`${API}/bookings/${booking.id}/auto-renew`, { enabled: next },
        { headers: { Authorization: `Bearer ${token}` } });
      toast.success(next ? "Weekly Auto-Renew is ON — renewals + reminders are now automatic." : "Weekly Auto-Renew turned OFF.");
      onSaved?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not update auto-renew.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button data-testid={`auto-renew-toggle-${booking.id}`} onClick={toggle} disabled={busy}
      className={`text-xs flex items-center gap-1.5 px-3 py-1.5 rounded border transition-colors disabled:opacity-50 ${on
        ? "border-emerald-500 bg-emerald-500/15 text-emerald-300 hover:brightness-125"
        : "border-white/20 text-white/60 hover:border-emerald-500/60 hover:text-emerald-300"}`}>
      {busy ? <Loader2 className="animate-spin" size={13} /> : <Repeat size={13} />}
      Weekly Auto-Renew: {on ? "ON" : "OFF"}
    </button>
  );
};

export default AutoRenewToggle;
